import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JdToolTipDirective } from './tool-tip.directive';
import { JdToolTipComponent } from './tool-tip.component';
import { OverlayModule } from '@angular/cdk/overlay';

const EXPORTS = [JdToolTipDirective, JdToolTipComponent];

@NgModule({
  imports: [CommonModule, OverlayModule],
  declarations: [...EXPORTS],
  exports: [...EXPORTS],
  entryComponents: [JdToolTipComponent]
})
export class JdToolTipModule {}
